"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualHomeWidgets = void 0;
var AnnualHomeFixedAddonWidget_1 = require("./AnnualHomeFixedAddonWidget");
var AnnualHomePremiumChoiceWidget_1 = require("./AnnualHomePremiumChoiceWidget");
var AnnualHomePersonalPossessionsWidget_1 = require("./AnnualHomePersonalPossessionsWidget");
var CustomYearWidget_1 = require("../../CustomYearWidget");
var AnnualHomePropertyTypeWidget_1 = require("./AnnualHomePropertyTypeWidget");
var AnnualHomePropertyUseSummaryWidget_1 = require("./AnnualHomePropertyUseSummaryWidget");
var AnnualHomePropertyDetailsSummaryWidget_1 = require("./AnnualHomePropertyDetailsSummaryWidget");
var AnnualHomePolicyHolderDetailsSummaryWidget_1 = require("./AnnualHomePolicyHolderDetailsSummaryWidget");
var HomeExcessWidget_1 = require("./HomeExcessWidget");
var QuotePremiumOutput_1 = require("./QuotePremiumOutput");
var CoverPanelWidget_1 = require("./CoverPanelWidget");
var AnnualHomeValuableItemsWidget_1 = require("./valuableItemWidget/AnnualHomeValuableItemsWidget");
var AnnualHomeTierWidget_1 = require("./AnnualHomeTierWidget");
var AnnualHomeStickyPriceWidget_1 = require("./AnnualHomeStickyPriceWidget");
var AnnualHomeBicyclesWidget_1 = require("./valuableItemWidget/AnnualHomeBicyclesWidget");
var AnnualHomeExtraCoversSummaryWidget_1 = require("./AnnualHomeExtraCoversSummaryWidget");
var AnnualHomeExcessOutput_1 = require("./AnnualHomeExcessOutput");
var ClaimValueWidget_1 = require("./ClaimValueWidget");
var AnnualHomeSpecifiedItemsAndBicyclesSummaryWidget_1 = require("./AnnualHomeSpecifiedItemsAndBicyclesSummaryWidget");
var DirectDebitPaymentPlanOutput_1 = require("./directDebit/DirectDebitPaymentPlanOutput");
var DirectDebitGuaranteeModal_1 = require("./directDebit/DirectDebitGuaranteeModal");
var HomeCoverView_1 = require("./mta/HomeCoverView");
var ChangeAddressQuotePremiumOutput_1 = require("./changeAddress/ChangeAddressQuotePremiumOutput");
var AnnualProductPaymentChoiceWidget_1 = require("../common/AnnualProductPaymentChoiceWidget");
var SupportPortalAnnualHomePaymentChoiceWidget_1 = require("./agentPortal/SupportPortalAnnualHomePaymentChoiceWidget");
var AnnualHomeCountChangePopUpWidget_1 = require("./mta/AnnualHomeCountChangePopUpWidget");
var AnnualHomeRemovedValuableItemsWidget_1 = require("./AnnualHomeRemovedValuableItemsWidget");
var AnnualHomeRemovedBicyclesWidget_1 = require("./AnnualHomeRemovedBicyclesWidget");
var ForcedPaymentPlanChangeModalWidget_1 = require("../common/ForcedPaymentPlanChangeModalWidget");
var AnnualHomeEligibleTiersWarningModal_1 = require("./AnnualHomeEligibleTiersWarningModal");
var AnnualHomeDocumentListWidget_1 = require("./AnnualHomeDocumentListWidget");
var AnnualHomeValuableItemsForRemovalWidget_1 = require("./AnnualHomeValuableItemsForRemovalWidget");
var TrustPilotAndDefaqtoWidget_1 = require("./TrustPilotAndDefaqtoWidget");
var HomeRenewalDeclineWordingWidget_1 = require("../../declineTextOutputWidget/HomeRenewalDeclineWordingWidget");
var AnnualHomeQuickQuoteAddressWidget_1 = require("./AnnualHomeQuickQuoteAddressWidget");
var GoldSuggestionModal_1 = require("./mta/GoldSuggestionModal");
var TierSummaryWidget_1 = require("../common/TierSummaryWidget");
var RatingsAndAwardsWidget_1 = require("../common/RatingsAndAwardsWidget");
var HomeCoverTierInShortWidget_1 = require("./HomeCoverTierInShortWidget");
var DirectJourneyQuoteHeadingOutputWidget_1 = require("./DirectJourneyQuoteHeadingOutputWidget");
var AnnualHomePaymentChoiceWordingWidget_1 = require("./mta/AnnualHomePaymentChoiceWordingWidget");
var AnnualHomeSummaryPagePremiumWidget_1 = require("./AnnualHomeSummaryPagePremiumWidget");
var ExtrasCarouselWidget_1 = require("./mta/ExtrasCarouselWidget");
var AnnualHomeCoverLevelRadioWidget_1 = require("./AnnualHomeCoverLevelRadioWidget");
var AnnualHomeCurrentTierDeclinedWarningModal_1 = require("./AnnualHomeCurrentTierDeclinedWarningModal");
var HomeCoverExcessWidget_1 = require("./mta/HomeCoverExcessWidget");
var AnnualHomeChangesWidget_1 = require("./AnnualHomeChangesWidget");
var UnsavedChangesModal_1 = require("./mta/UnsavedChangesModal");
var AnnualHomeRenewalChangesDateBanner_1 = require("./AnnualHomeRenewalChangesDateBanner");
var AnnualHomePropertyDetailsBanner_1 = require("./AnnualHomePropertyDetailsBanner");
var AnnualHomeChangeAddressBanner_1 = require("./AnnualHomeChangeAddressBanner");
var addAnnualHomeWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeFixedAddonWidget",
        component: AnnualHomeFixedAddonWidget_1.AnnualHomeFixedAddonWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomePremiumChoice",
        component: AnnualHomePremiumChoiceWidget_1.AnnualHomePremiumChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeExcessWidget",
        component: HomeExcessWidget_1.HomeExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "quotePremiumOutput",
        component: QuotePremiumOutput_1.QuotePremiumOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "ChangeAddressQuotePremiumOutput",
        component: ChangeAddressQuotePremiumOutput_1.ChangeAddressQuotePremiumOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeCoverView",
        component: HomeCoverView_1.HomeCoverView
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeCoverExcess",
        component: HomeCoverExcessWidget_1.HomeCoverExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeExcessOutput",
        component: AnnualHomeExcessOutput_1.AnnualHomeExcessOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomePersonalPossessions",
        component: AnnualHomePersonalPossessionsWidget_1.AnnualHomePersonalPossessionsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomePropertyTypeOutput",
        component: AnnualHomePropertyTypeWidget_1.AnnualHomePropertyTypeWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customYear",
        component: CustomYearWidget_1.CustomYearWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "propertyUseSummaryWidget",
        component: AnnualHomePropertyUseSummaryWidget_1.AnnualHomePropertyUseSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualProductPaymentChoice",
        component: AnnualProductPaymentChoiceWidget_1.AnnualProductPaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalAnnualProductPaymentChoice",
        component: SupportPortalAnnualHomePaymentChoiceWidget_1.SupportPortalAnnualHomePaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "propertyDetailsSummaryWidget",
        component: AnnualHomePropertyDetailsSummaryWidget_1.AnnualHomePropertyDetailsSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "policyHolderDetailsSummaryWidget",
        component: AnnualHomePolicyHolderDetailsSummaryWidget_1.AnnualHomePolicyHolderDetailsSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeValuableItemsWidget",
        component: AnnualHomeValuableItemsWidget_1.AnnualHomeValuableItemsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeRemovedValuableItemsWidget",
        component: AnnualHomeRemovedValuableItemsWidget_1.AnnualHomeRemovedValuableItemsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeValuableItemsForRemovalWidget",
        component: AnnualHomeValuableItemsForRemovalWidget_1.AnnualHomeValuableItemsForRemovalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "extraCoversSummaryWidget",
        component: AnnualHomeExtraCoversSummaryWidget_1.AnnualHomeExtraCoversSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "specifiedItemsAndBicyclesSummaryWidget",
        component: AnnualHomeSpecifiedItemsAndBicyclesSummaryWidget_1.AnnualHomeSpecifiedItemsAndBicyclesSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "coverPanel",
        component: CoverPanelWidget_1.CoverPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeTier",
        component: AnnualHomeTierWidget_1.AnnualHomeTierWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeRemovedBicyclesWidget",
        component: AnnualHomeRemovedBicyclesWidget_1.AnnualHomeRemovedBicyclesWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeBicycles",
        component: AnnualHomeBicyclesWidget_1.AnnualHomeBicyclesWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeStickyPrice",
        component: AnnualHomeStickyPriceWidget_1.AnnualHomeStickyPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "claimValue",
        component: ClaimValueWidget_1.ClaimValueWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitPaymentPlanOutput",
        component: DirectDebitPaymentPlanOutput_1.DirectDebitPaymentPlanOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitGuarantee",
        component: DirectDebitGuaranteeModal_1.DirectDebitGuaranteeModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeCountChangePopUpWidget",
        component: AnnualHomeCountChangePopUpWidget_1.AnnualHomeCountChangePopUpWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "goldSuggestionModal",
        component: GoldSuggestionModal_1.GoldSuggestionModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "forcedPaymentPlanChangeModal",
        component: ForcedPaymentPlanChangeModalWidget_1.ForcedPaymentPlanChangeModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "eligibleTiersModal",
        component: AnnualHomeEligibleTiersWarningModal_1.AnnualHomeEligibleTiersWarningModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeDocumentListWidget",
        component: AnnualHomeDocumentListWidget_1.AnnualHomeDocumentListWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "trustPilotAndDefaqtoWidget",
        component: TrustPilotAndDefaqtoWidget_1.TrustPilotAndDefaqtoWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeRenewalDeclineWordingWidget",
        component: HomeRenewalDeclineWordingWidget_1.HomeRenewalDeclineWordingWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeQuickQuoteAddressWidget",
        component: AnnualHomeQuickQuoteAddressWidget_1.AnnualHomeQuickQuoteAddressWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "tierSummaryWidget",
        component: TierSummaryWidget_1.TierSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "ratingsAndAwardsWidget",
        component: RatingsAndAwardsWidget_1.RatingsAndAwardsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeCoverTierInShortWidget",
        component: HomeCoverTierInShortWidget_1.HomeCoverTierInShortWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directJourneyQuoteHeadingOutput",
        component: DirectJourneyQuoteHeadingOutputWidget_1.DirectJourneyQuoteHeadingOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomePaymentChoiceWording",
        component: AnnualHomePaymentChoiceWordingWidget_1.AnnualHomePaymentChoiceWordingWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeSummaryPagePremiumOutput",
        component: AnnualHomeSummaryPagePremiumWidget_1.AnnualHomeSummaryPagePremiumWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "extrasCarousel",
        component: ExtrasCarouselWidget_1.ExtrasCarouselWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "homeCoverLevelRadio",
        component: AnnualHomeCoverLevelRadioWidget_1.AnnualHomeCoverLevelRadioWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeCurrentTierDeclinedWarningModal",
        component: AnnualHomeCurrentTierDeclinedWarningModal_1.AnnualHomeCurrentTierDeclinedWarningModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeChangesWidget",
        component: AnnualHomeChangesWidget_1.AnnualHomeChangesWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "unsavedChangesModal",
        component: UnsavedChangesModal_1.UnsavedChangesModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeRenewalChangesDateBanner",
        component: AnnualHomeRenewalChangesDateBanner_1.AnnualHomeRenewalChangesDateBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomePropertyDetailsBanner",
        component: AnnualHomePropertyDetailsBanner_1.AnnualHomePropertyDetailsBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualHomeChangeAddressBanner",
        component: AnnualHomeChangeAddressBanner_1.AnnualHomeChangeAddressBanner
    });
};
exports.addAnnualHomeWidgets = addAnnualHomeWidgets;
//# sourceMappingURL=index.js.map